export type MediaDefinitions = { [s: string]: string };

export const DEFAULT_BREAKPOINT_DEFINITIONS: MediaDefinitions = {
  palm: "0px",
  lapAndUp: "720px",
  desk: "1025px",
};
